import {
  AccountName,
  CaptionWrapper,
  CustomerName,
  InfoFrom,
  Invoice,
  Title,
} from './styles';

interface ICaptionProps {
  invoice: string;
  prefix: string;
  customer: string;
  account: string;
  workOrderNumber?: string;
}

const Caption = ({
  invoice,
  prefix,
  customer,
  account,
  workOrderNumber,
}: ICaptionProps) => (
  <CaptionWrapper>
    <Title>
      <Invoice>
        {invoice}
        {prefix}
        {workOrderNumber && ` | ${workOrderNumber}`}
      </Invoice>
      <InfoFrom>
        <AccountName> {account}</AccountName>
        <CustomerName> • {customer}</CustomerName>
      </InfoFrom>
    </Title>
  </CaptionWrapper>
);

export default Caption;
